import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/site-data";
import { HelpCircle } from "lucide-react";

export const FAQSection = () => {
  return (
    <section
      id="gyik"
      data-testid="faq-section"
      className="section-pad bg-white relative overflow-hidden"
    >
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#EA580C]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 relative">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="eyebrow">Gyakori kérdések</span>
            <h2 className="mt-3 font-heading font-bold text-[#0B192C] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Mielőtt felhívna minket – néhány válasz.
            </h2>
            <p className="mt-5 text-gray-600 text-base sm:text-lg leading-relaxed">
              Nem találja a választ? Kérdezzen bátran telefonon vagy az
              ajánlatkérő űrlapon.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 text-[#1E3E62]">
              <div className="w-10 h-10 rounded-full bg-[#EA580C]/10 text-[#EA580C] flex items-center justify-center">
                <HelpCircle className="w-5 h-5" />
              </div>
              <span className="font-semibold">Akár 24 órán belül válaszolunk munkanapokon.</span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Accordion
              type="single"
              collapsible
              className="bg-[#F8FAFC] rounded-lg border border-gray-200 px-5 md:px-7"
              data-testid="faq-accordion"
            >
              {FAQ.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`q-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-gray-200"
                >
                  <AccordionTrigger className="font-heading font-semibold text-[#0B192C] text-base md:text-lg hover:no-underline py-5 text-left">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 text-sm md:text-base leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
